<template>
    <letter-layout
        title="入目无他人，四下皆是你"
        date="2026年3月1日"
        sign-date="2026年3月10日"
        :paragraphs="paragraphs"
    />
</template>

<script>
import LetterLayout from './letterLayout.vue';

export default {
    components: { LetterLayout },
    data() {
        return {
            paragraphs: [
                '入目无他人，四下皆是你！',
                '你迟到了很多年，可我依然为你的到来而高兴。能给你的东西实在不多，这辈子只想把最单纯的喜欢和数不尽的温柔都给你！',
                '最真实的爱：不是天天开心，而是明明不快乐，却还是不想放手。',
                '有些遇见，从一开始就注定是遗憾。就像一场突如其来的雨，你撑着伞出现，陪我走了一段路，可走到路口，你轻轻说了一句再见，便转身消失在人海。'
            ]
        };
    }
};
</script>
